import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { EmbedLocalComponent } from './embed-local.component';
import { EmbedComponent } from './embed.component';

@NgModule({
  imports: [MatProgressBarModule, MatIconModule],
  declarations: [EmbedComponent, EmbedLocalComponent],
  exports: [EmbedComponent, EmbedLocalComponent],
})
export class EmbedModule {}
